/* eslint-disable no-console */
import { generatePath, matchPath } from 'react-router-dom';
import { ROOT_PATH } from 'utils/constants/app.js'

const ROOT_PATH_WITH_LABORATORY = `${ROOT_PATH}laboratory/:laboratory/`;
const ROOT_PATH_WITH_TEST = `${ROOT_PATH_WITH_LABORATORY}tests/:ptldId`;
const ROOT_PATH_WITH_ACCOUNT = `${ROOT_PATH_WITH_LABORATORY}account/`;
const ROOT_PATH_ACCOUNT = `${ROOT_PATH}account/`;

export const ROUTES = {
  ERROR: `${ROOT_PATH}error`,
  DOWNLOAD: {
    PUBLIC: `${ROOT_PATH}download`,
    PRIVATE: `${ROOT_PATH}private/download`
  },
  CHOICE: `${ROOT_PATH}laboratory-choice`,
  ADMINISTRATION: {
    GENERAL: `${ROOT_PATH_WITH_LABORATORY}administration`,
    USER_CREATE: `${ROOT_PATH_WITH_LABORATORY}administration/usersList/createUser`,
    USER_EDIT: `${ROOT_PATH_WITH_LABORATORY}administration/usersList/:personContactDetailsId`
  },
  HOME: `${ROOT_PATH_WITH_LABORATORY}home`,
  TESTS: `${ROOT_PATH_WITH_LABORATORY}tests`,
  TEST: {
    BASE: `${ROOT_PATH_WITH_TEST}`
  },
  ACCOUNT: {
    BASE: `${ROOT_PATH_WITH_ACCOUNT}`,
    PROFILE: `${ROOT_PATH_WITH_ACCOUNT}profile`,
    COOKIES: `${ROOT_PATH_WITH_ACCOUNT}cookies`
  },
  GENERAL_ACCOUNT: {
    BASE: `${ROOT_PATH_ACCOUNT}`,
    PROFILE: `${ROOT_PATH_ACCOUNT}profile`,
    COOKIES: `${ROOT_PATH_ACCOUNT}cookies`
  },
  AUDITS: `${ROOT_PATH_WITH_LABORATORY}audits`,
  LABO_ADMIN: {
    GENERAL: `${ROOT_PATH_WITH_LABORATORY}laboAdmin`,
    USER_CREATE: `${ROOT_PATH_WITH_LABORATORY}laboAdmin/usersList/createUser`,
    USER_EDIT: `${ROOT_PATH_WITH_LABORATORY}laboAdmin/usersList/:personContactDetailsId`
  },
  BASE: `${ROOT_PATH}laboratory/:laboratory`
};

export const GENERATE_ROUTE = (route, dict) => {
  const placeholderRegexp = /:([^/:]+)\/?/g
  const placeholders = [...route.matchAll(placeholderRegexp)];

  placeholders.forEach((match) => {
    const param = match[1];
    if (!dict[param]) {
      console.warn(`No ${param} supplied, link will not work ${route}`);
      return '';
    }
  })

  return generatePath(route, dict);
}

export const ROUTE_MATCHES = (location, route) => matchPath(location.pathname, {
  path: route,
  exact: false
});

export const GENERATE_TAB_VALUE = (location, route) => (ROUTE_MATCHES(location, route) ? 0 : NaN);